import React from "react";

import clsx from "clsx";
import { loginUrl } from "components/layout/navigation";
import Image from "next/image";

import Heading from "../../heading";
import {
  address1,
  address2,
  baseMapUrl,
  encodedAddress,
  mapLoader,
} from "./headquarters-map";
import styles from "./index.module.css";

const HelpAndSupport = ({ className }: { className?: string }) => (
  <div className={clsx(className, "space-y-6 md:space-y-10")}>
    <div>
      <div>
        <Heading tag="h4" className="text-center md:text-left">
          Get Help & Support
        </Heading>
        <p className={styles.subheading}>
          Forget your password? Have questions? Our Enerflo Support Specialists are here to help!
        </p>
      </div>
      <address className="space-y-3 not-italic mt-2 md:mt-4">
        <div className={clsx(styles.contactItem, styles.itemPadding)}>
          <p className={styles.infoLabel}>Contact Support</p>
          <a href="mailto:support@enerflo.io" className="text-primary text-base md:text-lg">
            support@enerflo.io
          </a>
        </div>
        <div className={clsx(styles.contactItem, styles.itemPadding, "space-y-4 md:space-y-6")}>
          <div>
            <p className={styles.infoLabel}>Chat with Support</p>
            <p className="mt-1">
              <a href={loginUrl} className="text-primary">
                Login to Enerflo
              </a>{" "}
              to Chat with Support during Support Hours
            </p>
          </div>
          <div>
            <p className={styles.infoLabel}>Support Hours</p>
            <p className="text-base md:text-lg">Monday - Saturday (Closed Sundays)</p>
            <p className="text-base md:text-lg">6:00am - 7:00pm PT</p>
            <p className="text-base md:text-lg">(9:00am - 10:00pm ET)</p>
          </div>
        </div>
      </address>
    </div>
    <div>
      <Heading tag="h4" className="text-center md:text-left">
        General Inquiries
      </Heading>
      <address className="space-y-3 not-italic mt-2 md:mt-4">
        <div className={clsx(styles.contactItem, styles.itemPadding)}>
          <p className={styles.infoLabel}>For Sales & Marketing Inquiries Only (NOT for Support)</p>
          <a href="tel:562-582-7728" className="text-primary text-base md:text-lg">
            1 (562) 582-7728
          </a>
        </div>
        <div className={clsx("flex flex-col sm:flex-row flex-wrap overflow-hidden", styles.contactItem)}>
          <div className="relative flex-1 w-full sm:w-1/2 min-w-[200px] min-h-[125px] border-r border-gray-200 overflow-hidden">
            <a href={`${baseMapUrl}${encodedAddress}`} target="_blank" rel="noreferrer">
              <Image
                src={`?center=${encodedAddress}&key=${process.env.GOOGLE_API_KEY}&zoom=14&markers=color:0x42a4ff%7C33.665970,-117.988060`}
                alt="Enerflo Headquaters Map"
                loader={mapLoader}
                layout="fill"
                className="object-center object-cover"
              />
            </a>
          </div>
          <div className={clsx("flex-1 min-w-[200px]", styles.itemPadding)}>
            <p className={clsx("mb-2", styles.infoLabel)}>Enerflo Headquarters</p>
            <p>{address1}</p>
            <p>{address2}</p>
          </div>
        </div>
      </address>
    </div>
  </div>
);

export default HelpAndSupport;
